import GhostContentAPI from '@tryghost/content-api'
import Zooming from 'zooming'
import * as basicLightbox from './lightbox'

import { Map, View, Feature } from 'ol'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Zoomify from 'ol/source/Zoomify'
import { defaults as defaultControls, Attribution } from 'ol/control'
import Projection from 'ol/proj/Projection'
import { getCenter } from 'ol/extent'
import Polygon from 'ol/geom/Polygon'
import { Select } from 'ol/interaction'
import { Fill, Stroke, Style } from 'ol/style'

let apiKey
window.location.origin.startsWith('http://')
  ? (apiKey = '9a90f225180f486b107fe04f51')
  : (apiKey = '5b8886cf76a357921057423db4')

const api = new GhostContentAPI({
  url: window.location.origin,
  key: apiKey,
  version: 'v3',
})

var dt = new Date()
const attributions = `&copy; ${dt.getFullYear()} - <a href="/">Vato Sikharulidze</a> - <a href="/privacy">Impressum</a> - <a href="/contact">Contact</a>`

const imgWidth = 4032
const imgHeight = 3024
const zoomifyUrl = '/assets/dots_opti3/'
const extent = [0, 0, imgWidth, imgHeight]

const zoomifySource = new Zoomify({
  url: zoomifyUrl,
  size: [imgWidth, imgHeight],
  crossOrigin: 'same',
  zDirection: -1,
  extent: extent,
  attributions: attributions,
})
const vectorSource = new VectorSource()

const vectorLayer = new VectorLayer({
  source: vectorSource,
  style: new Style({
    stroke: new Stroke({
      color: 'rgba(64, 64, 64, 0.8)',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(64, 64, 64, 0.8)',
    }),
  }),
})

const baseLayer = new TileLayer({
  source: zoomifySource,
  preload: Infinity,
})

const map = new Map({
  controls: defaultControls({}).extend([
    new Attribution({ label: 'i', collapseLabel: 'c', tipLabel: 'Informations' }),
  ]),
  layers: [baseLayer, vectorLayer],
  target: 'map',
  view: new View({
    projection: new Projection({
      units: 'pixels',
      extent: extent,
    }),
    extent: extent,
    smoothExtentConstraint: false,
    center: getCenter(extent),
    zoom: 1,
    minZoom: 1,
    maxZoom: 5,
  }),
})

map.once('postcompose', function () {
  // for all posts add a point (feature)
  api.posts
    .browse({ include: 'tags' })
    .then((posts) => {
      posts.forEach((post) => {
        if (post.excerpt) {
          var polyCoords = []
          post.excerpt.split('\n').forEach((line) => {
            let px = Number.parseFloat(line.split(',')[0])
            let py = Number.parseFloat(line.split(',')[1])
            polyCoords.push([px, py])
          })
          var feature = new Feature({
            geometry: new Polygon([polyCoords]),
          })
          feature.setId(post.slug)
          vectorSource.addFeature(feature)
        } else {
          console.info(
            `post.excerpt not set or could not split: ${post.excerpt} for post: ${post.slug}`
          )
        }
      })
    })
    .catch((err) => {
      console.log(err)
    })
})

var select = new Select({ hitTolerance: 20 })
map.addInteraction(select)

select.on('select', function (e) {
  document.getElementById('cursor2').classList.remove('hover')
  document.getElementById('cursor3').classList.remove('hover')

  let feature = e.target.getFeatures()
  var id = feature.item(0).getId()
  api.posts
    .read({ slug: id })
    .then((post) => {
      const button = `<div class="ol-close ol-control"><button class="ol-close-btn .ol-control" type="button" title="Close">x</button></div>`
      let content = post.html
      var postContent = button + content
      window.box = basicLightbox.create(postContent, {
        closable: true,
        onShow: (_) => {
          history.pushState(null, id, id)
          document.querySelectorAll('.curs').forEach((ele) => {
            ele.hidden = true
          })
        },
        onClose: (_) => {
          document.querySelectorAll('.curs').forEach((ele) => {
            ele.hidden = false
          })
          history.replaceState(null, null, `${window.location.origin}/work/`)
        },
      })

      window.box.show((_) => {
        feature.clear()
        const zoom = new Zooming({
          bgOpacity: 0,
          enableGrab: false,
          preloadImage: true,
          zIndex: 1200,
        }).listen('img')
      })
      document.querySelector('.ol-close button').addEventListener('click', (_) => {
        document.querySelectorAll('.curs').forEach((ele) => {
          ele.hidden = false
        })
        window.box.close()
      })
    })
    .catch((err) => {
      console.log(err)
    })
})

window.onload = function () {
  if (!isTouch()) {
    map.on('pointermove', function (e) {
      var selected = null
      map.forEachFeatureAtPixel(e.pixel, function (f) {
        selected = true
      })
      if (selected) {
        document.getElementById('cursor2').classList.add('hover')
        document.getElementById('cursor3').classList.add('hover')
        this.getTargetElement().style.cursor = 'pointer'
      } else {
        this.getTargetElement().style.cursor = ''
        document.getElementById('cursor2').classList.remove('hover')
        document.getElementById('cursor3').classList.remove('hover')
      }
    })
  }
  if (!isTouch()) {
    document
      .getElementsByTagName('body')[0]
      .addEventListener('mousemove', (event) => cursorAnimation(event))
  }
  window.addEventListener('popstate', function (event) {
    if (typeof window.box !== 'undefined') {
      window.box.close()
    }
  })
}

function isTouch() {
  return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
}

function cursorAnimation(event) {
  event.preventDefault()
  requestAnimationFrame(function () {
    document.getElementById('cursor').style.left = event.clientX + 'px'
    document.getElementById('cursor').style.top = event.clientY + 'px'
    document.getElementById('cursor2').style.left = event.clientX + 'px'
    document.getElementById('cursor2').style.top = event.clientY + 'px'
    document.getElementById('cursor3').style.left = event.clientX + 'px'
    document.getElementById('cursor3').style.top = event.clientY + 'px'
  })
}
